export function dataLayerPageView(pagetype, event, shardId, emailHash, emailNoHash) {
    if (typeof dataLayer !== 'undefined') {
        if (shardId) {
            dataLayer.push({
                'page': { 'type': pagetype },
                'user': { 'id': shardId, 'type': 'Account', 'email': emailHash, 'emailaddress': emailNoHash },
                'event': event
            });
        }
        else {
            dataLayer.push({
                'page': { 'type': pagetype },
                'event': event
            });
        }
    }
}